const routes = [
    {
        path: "/bulk/grade/entry/:sectionId",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission:'course_search'
        },
        component_full_path: "BulkGradeEntry/pages/Index"
    }
];

export default routes;
